<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 13:56:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-27 15:04:54
 * @Description: checkbox group
 * @FilePath: /hsylc2021/src/components/form/CheckboxGroup/Prototype.vue
-->
<template>
  <div class="component-radiogroup" :class="computedClass">
    <Checkbox
      class="component-radiogroup-checkbox"
      v-for="item in radioList"
      :key="item[keyStr]"
      :label="item._ori.label"
      v-model="item._selected"
      @input="handleClickItem"
      :_id="item._ori[keyStr]"
      :reverse="reverse"
      :disabled="disabled"
      :class="CheckboxClass"
    />
    <slot></slot>
  </div>
</template>
<script>
import clone from 'clone';
import Checkbox from '../Checkbox';
/**
 * checkbox group组件
 * @module CheckboxGroup
 */
export default {
  name: 'CheckboxGroup',
  components: {
    Checkbox
  },
  /**
   * @prop {String} className 组件外部class
   * @prop {Boolean} disabled 是否禁用
   * @prop {Array} value 组件数据
   * @prop {Array} options 组件来源数据列表
   * @prop {String} keyStr 唯一标志字段名，默认value
   * @prop {Boolean} reverse 是否支持反选 默认true
   * @prop {Boolean} multi 是否支持多选 默认true
   * @prop {Boolean} errmsg 报错信息 默认 未填写
   */
  props: {
    CheckboxClass: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyStr: {
      type: String,
      default: 'value'
    },
    reverse: {
      type: Boolean,
      default: true
    },
    multi: {
      type: Boolean,
      default: true
    }
  },
  /**
   * @prop {Object} computedClass 计算class
   * @prop {Array} radioList 根据数据源最终计算出radio数据
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    radioList() {
      return this.options.map(item => {
        let ret = clone({
          _selected: false,
          _ori: clone(item)
        });
        if (this.value && this.value.find(_item => _item[this.keyStr] === item[this.keyStr])) {
          ret._selected = true;
        }
        return ret;
      });
    }
  },
  methods: {
    /**
     * @event input v-model input事件
     * @param {Array} 选中的对象
     */
    /**
     * @description 点击事件
     * @function handleClickItem
     * @param {String} value 点击item的value
     * @param {String} _id 点击item的key
     */
    handleClickItem: function(value, _id) {
      if (!this.disabled) {
        let ret = [];
        let curObj = {};
        let radioList = clone(this.radioList).map(item => {
          let res = clone(item);
          if (res._ori[this.keyStr] === _id) {
            res._selected = value;
            curObj = res._ori;
          } else if (!this.multi) {
            res._selected = false;
          }
          return res;
        });
        ret = radioList.filter(item => item._selected).map(item => item._ori);
        this.$emit('input', ret, curObj);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.component-radiogroup {
  .component-radiogroup-checkbox {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
